import React from 'react'
import { BrowserRouter, Router, Link, Route, Switch, useHistory, Redirect, HashRouter } from 'react-router-dom'
import AttemptAuth from '../auth/AttemptAuth';
// import _Login from '../auth/_Login';
import MainLayouts from '../layouts/MainLayouts';

// import DataArsip from '../pages/Pengadaan/DataArsip';
// import ShowDataPengadaan from '../pages/Pengadaan/ShowData/ShowDataPengadaan';
import { Cache } from '../services/Cache';
import ProtectedRoute from '../services/Route/ProtectedRoute';
import { globalText } from '../services/Text/GlobalText';
import RiwayatKonseling from '../pages/Konseling/RiwayatKonseling';
import VideoCall from '../pages/VC/VideoCall';
import ProsesKonseling from '../pages/VC/ProsesKonseling';
import OrderKonseling from '../pages/OrderKonseling/OrderKonseling';
import RiwayatKonselingGizi from '../pages/Konseling/RiwayatKonselingGizi';
import Home from '../pages/Home/Home';
// import RegisterAuth from '../auth/RegisterAuth';
import AgoraVideoCall from '../pages/VC/agora/AgoraVideoCall';
import RegisterAuth from '../auth/RegisterAuth';
// import RegisterAuth from 'auth/RegisterAuth';
// import VideoCallKonseling from 'pages/VC/videoCallKonseling/VideoCallKonseling';
import VideoCallKonseling from '../pages/VC/videoCallKonseling/VideoCallKonseling';
import OrderKonselingMobile from 'pages/OrderKonseling/OrderKonselingMobile';
// import LoginMobile from 'auth/LoginMobile';
import RiwayatPolaMakan from 'pages/RiwayatPolaMakan/RiwayatPolaMakan';
import LoginMobile from '@/auth/LoginMobile';
import FormHidanganSehari from 'pages/FormHidanganSehari/FormHidanganSehari';
import OrderKonselingManual from 'pages/OrderKonseling/OrderKonselingManual';
import BuatDiet from 'pages/diet/BuatDiet';
import MappDiet from 'pages/diet/MappDiet';
import JitsiEmbed from 'pages/Jitsi/JitsiEmbed.jsx';
// import VideoCallKonseling from '../pages/VC/VideoCall';


function Routing() {
    const c404 = () => {
        return (
            <Redirect to={{ pathname: '/Home' }} />
        )
    }


    var ses = Cache.get(globalText.x_auth_resu)
    var us = {}
    if (ses) {
        us = JSON.parse(ses)
    }
    // var cek = JSON.parse()

    return (
        <BrowserRouter basename="/gizi/konseling">
            <Switch>
                <Route path="/Home" component={Home} />
                <Route path="/login" component={AttemptAuth} />
                <Route path="/login-mobile" component={LoginMobile} />
                <Route path="/AgoraVideoCall" component={AgoraVideoCall} />
                <Route path="/FormHidanganSehari" component={FormHidanganSehari} />
                {/* <ProtectedRoute path="/home" exact component={DataArsip} /> */}
                {/* <ProtectedRoute path="/DataArsip" component={DataArsip} /> */}
                <ProtectedRoute path="/OrderKonseling" component={OrderKonseling} />
                <ProtectedRoute path="/OrderKonselingManual" component={OrderKonselingManual} />
                <Route path="/OrderKonselingMobile" component={OrderKonselingMobile} />
                <ProtectedRoute path="/VideoCallKonseling" component={VideoCallKonseling} />
                {/* <ProtectedRoute path="/ShowDataPengadaan" component={ShowDataPengadaan} /> */}
                <ProtectedRoute path="/RiwayatKonseling" component={RiwayatKonseling} />
                <ProtectedRoute path="/VideoCall" component={VideoCall} />
                <ProtectedRoute path="/ProsesKonseling" component={ProsesKonseling} />
                <ProtectedRoute path="/RiwayatKonselingGizi" component={RiwayatKonselingGizi} />
                <ProtectedRoute path="/BuatDiet" component={BuatDiet} />
                <ProtectedRoute path="/MappDiet" component={MappDiet} />
                <Route path="/register-auth" component={RegisterAuth} />
                <Route path="/RiwayatPolaMakan" component={RiwayatPolaMakan} />
                <Route path="/JitsiEmbed" component={JitsiEmbed} />
                <Route path="*" exact component={() => c404()} />
            </Switch>
        </BrowserRouter>
    )

}

export default Routing
